export enum ESupportedCountries {
  AUS = "AUS",
  NZL = "NZL",
}
